import {atom} from "jotai";

const token = localStorage.getItem('refreshToken');

export const isAuthenticatedAtom = atom(!!token);

export const userAtom = atom<null | User>(null);

export const pageNameAtom = atom('');